import React, { useState, useEffect } from "react";
import "../App.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import Services from './Services'
import { Table } from "react-bootstrap";
import Form from 'react-bootstrap/Form'
import Pagination from "rc-pagination";
import "./pagination.css";
import { hospitalcodedata } from './hospitalcodedata';
import * as AiIcons from 'react-icons/ai';
import { confirmAlert } from 'react-confirm-alert';
import { RotatingLines } from "react-loader-spinner";

const moment = require("moment");

const MastersData = () => {

    const [loading, setLoading] = useState(false);

    const [masters, setmasters] = useState([]);
    const [filteredData, setFilteredData] = useState(masters);

    const [masterfilterdata, setmasterfilterdata] = useState({
        hospital_type: "",
        hospital_code: ""
    });

    const [hospitalfiltertype, sethospitalfiltertype] = useState([]);
    const [hospitalfiltercode, sethospitalfiltercode] = useState([]);

    useEffect(() => {
        try {

            const hospitaltype = [{ hospitaltype_name: "DME" }, { hospitaltype_name: "VVP" }];
            sethospitalfiltertype(hospitaltype);

            const filtered = hospitalcodedata.filter(hospitalcodedata => {
                return hospitalcodedata.hospitaltype_name === masterfilterdata.hospital_type;
            });

            sethospitalfiltercode(filtered);

        } catch (e) {
            console.log(e);
        }
    }, [masterfilterdata.hospital_type]);



    function handleChangeHospitaltypes(event, frm) {
        if (frm === "hspttype") {
            masterfilterdata.hospital_code = "";
        }
        const { name, value } = event.target;
        setmasterfilterdata({ ...masterfilterdata, [name]: value });
    }


    const handleSearchhospital = (event) => {
        let firstLetter = event.target.value.charAt(0);
        event.target.value = firstLetter.toUpperCase() + event.target.value.slice(1);

        let value = event.target.value.toUpperCase();
        let result = [];
        console.log(value);
        result = masters.filter((data) => {
            return data.hospital_type.toUpperCase().search(value) !== -1
                || data.hospital_code.toUpperCase().search(value) !== -1;
        });
        setFilteredData(result);
    }

    const handleChildTagsdataSearch = (event, from) => {

        let firstLetter = event.target.value.charAt(0);
        event.target.value = firstLetter.toUpperCase() + event.target.value.slice(1);

        let value = event.target.value.toUpperCase();
        let result = [];
        result = masters.filter((data) => {
            let fildata = "";
            if (from === "masterid") {
                fildata = data.master_id;
            } else if (from === "masterip") {
                fildata = data.master_iP;
            } else if (from === "Mastername") {
                fildata = data.master_name;
            } else if (from === "status") {
                fildata = data.master_status;
            }
            return fildata.toUpperCase().search(value) !== -1;
        });
        setFilteredData(result);
    }




    const getData = () => {

        if (validateviewForm()) {
            setLoading(true);

            setCurrent(1);

            const formData = new FormData()
            formData.append('hospital_type', masterfilterdata.hospital_type);
            formData.append('hospital_code', masterfilterdata.hospital_code);

            Services.getMastersdataByHospitalwise(formData).then((res) => {
                if (res.status === 200) {
                    if (res.data.status === true) {
                        const mastersdata = res.data.mastersdata;
                        mastersdata.sort((firstItem, secondItem) => firstItem.master_id - secondItem.master_id);
                        setmasters(mastersdata);
                        setFilteredData(mastersdata);
                        setLoading(false);

                    } else if (res.data.status === false) {
                        alert("Empty Data");
                        setmasters([]);
                        setFilteredData([]);
                        setLoading(false);

                    }
                } else Promise.reject();
            }).catch((error) => {
                setmasters([]);
                setFilteredData([]);
                alert("Something went wrong(" + error + ")");
                setLoading(false);

            });
        }
    }

    const validateviewForm = (e) => {

        let formIsValid = true;

        if (!masterfilterdata.hospital_type?.trim()) {
            alert("Select Hospital Type");
            formIsValid = false;
        } else if (!masterfilterdata.hospital_code?.trim()) {
            alert("Select Hospital Code");
            formIsValid = false;
        }

        return formIsValid;
    }


    const deleteMaster = (id, name) => {
        confirmAlert({
            title: 'Confirm to Delete',
            message: 'Are you sure you want to delete this Master == >  ' + name,
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => {

                        const formData = new FormData()
                        formData.append('hospital_type', masterfilterdata.hospital_type);
                        formData.append('hospital_code', masterfilterdata.hospital_code);
                        formData.append('_id', id);

                        Services.deleteMastersdataByHospitalwise(formData).then((res) => {

                            if (res.status === 200) {
                                if (res.data.status === true) {
                                    alert("Master successfully deleted");
                                    const mastersfilter = masters.filter(masters => masters._id !== id);
                                    setmasters(mastersfilter);
                                    setFilteredData(mastersfilter);
                                } else if (res.data.status === false) {
                                    alert("Something went wrong")
                                }
                            } else Promise.reject();

                        }).catch((err) => {
                            alert("Something went wrong(" + err + ")")
                        });
                    }
                },
                {
                    label: 'No',
                    onClick: () => {
                    }
                }
            ]
        });
    }





    const [perPage] = useState(15);
    const [size, setSize] = useState(perPage);
    const [current, setCurrent] = useState(1);

    const PerPageChange = (value) => {
        setSize(value);
        const newPerPage = Math.ceil(filteredData.length / value);
        if (current > newPerPage) {
            setCurrent(newPerPage);
        }
    }

    const currentData = (current, pageSize) => {
        // Normally you should get the data from the server
        return filteredData.slice((current - 1) * pageSize, current * pageSize);
    };

    const PaginationChange = (page, pageSize) => {
        setCurrent(page);
        setSize(pageSize)
    }

    const PrevNextArrow = (current, type, originalElement) => {
        if (type === 'prev') {
            return <button><i className="fa fa-angle-double-left"></i></button>;
        }
        if (type === 'next') {
            return <button><i className="fa fa-angle-double-right"></i></button>;
        }
        return originalElement;
    }

    // Return Agent form
    return (
        <div className="full_frame_center" >
            <div className="start_start" style={{
                background: "white", marginLeft: "1%", marginRight: "1%",
                marginTop: "10px", marginBottom: "50px", padding: "2%"
            }}>
                <div style={{ width: "100%" }}>
                    <div className="start_start" style={{ width: "100%" }}>
                        <h1 style={{ marginLeft: "10px", fontSize: "25px", fontWeight: "bold", color: "black" }}>Master Data</h1>
                    </div>

                    <div style={{ borderTop: "1px solid #000 ", marginBottom: "10px" }}></div>

                    <div className="start_start" style={{ width: "100%", marginLeft: "2%", marginTop: "2%" }}>

                        <div className="start_center" style={{ width: "50%", flexDirection: "row" }}>
                            <div className="start_start" style={{ width: "100%", flexDirection: "row" }}>

                                <div className="start_start" style={{ width: "100%", flexDirection: "column", marginBottom: "20px" }}>
                                    <label htmlFor="hospital_type" className='text-controol' style={{ color: "#190262", fontSize: "12px", fontWeight: "bold" }}>
                                        Hospital Type<b style={{ color: "red" }}>*</b></label>
                                    <Form.Select aria-label="Default select example" name="hospital_type" value={masterfilterdata.hospital_type}
                                        onChange={(event) => handleChangeHospitaltypes(event, "hspttype")} style={{ fontSize: "12px", fontWeight: "bold", width: "70%" }} >
                                        <option value="">SELECT</option>
                                        {hospitalfiltertype.map((hospitalfiltertype, index) => (
                                            <option key={index} value={hospitalfiltertype.hospitaltype_name}>{hospitalfiltertype.hospitaltype_name}</option>
                                        ))}
                                    </Form.Select>
                                </div>

                                <div className="start_start" style={{ width: "100%", flexDirection: "column", marginBottom: "20px" }}>
                                    <label htmlFor="hospital_code" className='text-controol' style={{ color: "#190262", fontSize: "12px", fontWeight: "bold" }}>
                                        Hospital Code<b style={{ color: "red" }}>*</b></label>
                                    <Form.Select aria-label="Default select example" name="hospital_code" value={masterfilterdata.hospital_code}
                                        onChange={(event) => handleChangeHospitaltypes(event, "")} style={{ fontSize: "12px", fontWeight: "bold", width: "70%" }} >
                                        <option value="">SELECT</option>
                                        {hospitalfiltercode.map((hospitalfiltercode, index) => (
                                            <option key={index} value={hospitalfiltercode.hospitalcode_name}>{hospitalfiltercode.hospitalcode_name}</option>
                                        ))}
                                    </Form.Select>
                                </div>

                                <div className="start_start" style={{ width: "100%", flexDirection: "column", marginBottom: "20px" }}>
                                    <label htmlFor="getdata" className='text-controol' style={{ color: "#190262", fontSize: "12px", fontWeight: "bold" }}>
                                        Get</label>
                                    <button className="btn btn-primary" style={{
                                        background: "#190262", borderColor: "#190262", color: "#ffffff",
                                        fontSize: "12px"
                                    }} onClick={getData} >GET</button>
                                </div>

                            </div>

                        </div>
                    </div>

                    {loading ? (

                        <div className="center_center" style={{ width: "100%", display: "flex" }}>
                            <RotatingLines width="50px" height="50px" strokeColor="red" strokeWidth="8"
                                animationDuration="0.75" visible={true} />
                        </div>

                    ) : (

                        <div className="start_start" style={{ width: "100%", padding: "10px", flexDirection: "column" }}>
                            <Table striped bordered hover style={{ fontSize: "12px" }}>
                                <thead style={{ background: "lightsteelblue", color: "black" }}>
                                    <tr>
                                        <th style={{ background: "lightsteelblue", color: "black" }}>S.no</th>
                                        <th style={{ background: "lightsteelblue", color: "black" }}>Hospital</th>
                                        <th style={{ background: "lightsteelblue", color: "black" }}>Master Id</th>
                                        <th style={{ background: "lightsteelblue", color: "black" }}>Master IP NUM</th>
                                        <th style={{ background: "lightsteelblue", color: "black" }}>Master Name</th>
                                        <th style={{ background: "lightsteelblue", color: "black" }}>Master status</th>
                                        <th style={{ background: "lightsteelblue", color: "black" }}>Last Active Date</th>
                                        <th style={{ background: "lightsteelblue", color: "black" }}>Created Date</th>
                                        {/* <th style={{ background: "lightsteelblue", color: "black" }} >Action</th> */}
                                    </tr>
                                </thead>
                                <thead >
                                    <tr>
                                        <th></th>
                                        <th>
                                            <input type="text" className="form-control" placeholder="Hospital"
                                                style={{ fontSize: "12px" }} onChange={(event) => handleSearchhospital(event, "Hospital")} />
                                        </th>
                                        <th>
                                            <input type="text" className="form-control" placeholder="Master id"
                                                style={{ fontSize: "12px" }} onChange={(event) => handleChildTagsdataSearch(event, "masterid")} />
                                        </th>
                                        <th>
                                            <input type="text" className="form-control" placeholder="Master IP"
                                                style={{ fontSize: "12px" }} onChange={(event) => handleChildTagsdataSearch(event, "masterip")} />
                                        </th>
                                        <th>
                                            <input type="text" className="form-control" placeholder="Master Name"
                                                style={{ fontSize: "12px" }} onChange={(event) => handleChildTagsdataSearch(event, "Mastername")} />
                                        </th>
                                        <th>
                                            <input type="text" className="form-control" placeholder="Status"
                                                style={{ fontSize: "12px" }} onChange={(event) => handleChildTagsdataSearch(event, "status")} />
                                        </th>
                                        <th></th>
                                        <th></th>
                                        {/* <th></th> */}
                                    </tr>
                                </thead>
                                <tbody >
                                    {currentData(current, size).map((master, index) => (
                                        <tr key={index}>
                                            <td>{(current - 1) * perPage + index + 1}</td>
                                            <th>{master.hospital_type}({master.hospital_code})</th>
                                            <td>{master.master_id}</td>
                                            <td>{master.master_iP}</td>
                                            <td>{master.master_name}</td>
                                            <td>
                                                {(() => {
                                                    if (master.master_status === "Available") {
                                                        return (
                                                            <b style={{ color: "green" }}>{master.master_status} </b>
                                                        )
                                                    } else if (master.master_status === "Damaged") {
                                                        return (
                                                            <b style={{ color: "red" }}>{master.master_status} </b>
                                                        )
                                                    }
                                                })()}
                                            </td>
                                            <td>
                                                {(() => {
                                                    // Parse the last active date
                                                    var dateObject1 = moment(master.last_active_date, "DD/MM/YYYY HH:mm:ss").toDate();
                                                    var d = new Date();
                                                    d.setHours(d.getHours() - 2); // Subtract 1 hour
                                                    var dateObject2 = d; // Current date minus 1 hour
                                                    if (dateObject1) {
                                                        if (dateObject1 >= dateObject2) {
                                                            return <b style={{ color: "green" }}>{master.last_active_date}</b>;
                                                        } else {
                                                            return <b style={{ color: "red" }}>{master.last_active_date}</b>;
                                                        }
                                                    } else {
                                                        return <b style={{ color: "red" }}>{master.last_active_date}</b>;
                                                    }
                                                })()}
                                            </td>
                                            <td>{master.master_created_date}</td>
                                            {/* <td>
                                            <AiIcons.AiOutlineDelete style={{ color: "red", height: "20px", width: "20px", cursor: "pointer" }}
                                                onClick={(e) => deleteMaster(master._id, master.master_name)} />
                                        </td> */}
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                            <div >
                                <Pagination
                                    className="pagination-data"
                                    showTotal={(total, range) => `Showing ${range[0]}-${range[1]} of ${total}`}
                                    onChange={PaginationChange}
                                    total={filteredData.length}
                                    current={current}
                                    pageSize={size}
                                    showSizeChanger={false}
                                    showTitle={false}
                                    itemRender={PrevNextArrow}
                                    onShowSizeChange={PerPageChange} />
                            </div>
                        </div>

                    )}

                </div>
            </div>
        </div>
    );
};

// Export MastersData Component
export default MastersData;